import { useQuery } from "@tanstack/react-query";
import { getTestimonials } from "../../api/apiTestimonials";
import i18next from "i18next";

export function useGetTestimonials(params = {}) {
    const { isLoading, data, error, refetch } = useQuery({
        queryKey: ["testimonials", params, i18next.language],
        queryFn: () => getTestimonials(params),
        retry: false,
    });

    const items = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, items, meta, refetch };
}
